// Feather → Lucide name map. Keep in sync with migrations/62_icon-selection-app/content_types/constants.js
export const ICON_NAME_ALIASES: Record<string, string> = {
  "alert-circle": "circle-alert",
  "alert-octagon": "octagon-alert",
  "alert-triangle": "triangle-alert",
  "arrow-down-circle": "circle-arrow-down",
  "arrow-left-circle": "circle-arrow-left",
  "arrow-right-circle": "circle-arrow-right",
  "arrow-up-circle": "circle-arrow-up",
  "check-circle": "circle-check-big",
  "check-circle-2": "circle-check-big",
  "check-square": "square-check-big",
  "divide-circle": "circle-divide",
  "divide-square": "square-divide",
  "minus-circle": "circle-minus",
  "minus-square": "square-minus",
  "pause-circle": "circle-pause",
  "play-circle": "circle-play",
  "plus-circle": "circle-plus",
  "plus-square": "square-plus",
  "stop-circle": "circle-stop",
  "x-circle": "circle-x",
  "x-octagon": "octagon-x",
  "x-square": "square-x",
  "bar-chart": "chart-no-axes-column-increasing",
  "bar-chart-2": "chart-no-axes-column",
  "pie-chart": "chart-pie",
  "download-cloud": "cloud-download",
  "upload-cloud": "cloud-upload",
  edit: "square-pen",
  "edit-2": "pen",
  "edit-3": "pen-line",
  columns: "columns-2",
  filter: "funnel",
  "git-commit": "git-commit-horizontal",
  grid: "layout-grid",
  "help-circle": "circle-question-mark",
  home: "house",
  layout: "layout-dashboard",
  "more-horizontal": "ellipsis",
  "more-vertical": "ellipsis-vertical",
  pocket: "wallet",
  sidebar: "panel-left",
  slash: "ban",
  sliders: "sliders-vertical",
  table: "table-2",
  tool: "wrench",
  unlock: "lock-open",
  "align-center": "text-align-center",
  "align-justify": "text-align-justify",
  "align-left": "text-align-start",
  "align-right": "text-align-end",
  chrome: "globe",
  chromium: "globe",
  codepen: "folder-tree",
  codesandbox: "box",
  dribbble: "square-activity",
  facebook: "users",
  figma: "pen-tool",
  framer: "vector-square",
  github: "code",
  gitlab: "code",
  instagram: "aperture",
  linkedin: "briefcase",
  slack: "hash",
  trello: "square-kanban",
  twitch: "gamepad-2",
  twitter: "bird",
  youtube: "square-play",
};

export const normalizeIconName = (name: unknown): string => {
  if (typeof name !== "string") return "";

  const trimmed = name.trim();
  if (!trimmed) return "";

  const withoutPrefix = trimmed.startsWith("icon-") ? trimmed.slice(5) : trimmed;
  return ICON_NAME_ALIASES[withoutPrefix] ?? withoutPrefix;
};
